import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "id",
  "use": "id-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"id\"><path d=\"m22.09 11.58-9-9A2 2 0 0 0 11.68 2h-7a2 2 0 0 0-2 2v7a2 2 0 0 0 .59 1.42l9 9a2 2 0 0 0 1.41.58 2 2 0 0 0 1.41-.59l7-7a2 2 0 0 0 .59-1.41 2 2 0 0 0-.59-1.42ZM13.68 20l-9-9V4h7l9 9-7 7ZM7.18 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol